import * as React from 'react'
import Setting, { getTableSettingsColums } from '../../../Model/Setting'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject } from 'mobx-react'
import ReactTable from 'react-table'
import ConfigStore from '../../../Stores/ConfigStore'

export interface ISettingsViewProps {
    settings: Array<Setting>
    localizationStore?: LocalizationStore,
    configStore?: ConfigStore
}

@inject('configStore')
@inject('localizationStore')
export default class SettingsView extends React.Component<ISettingsViewProps> {
    render() {
        const { settings, localizationStore, configStore } = this.props

        if (!settings) {
            return (<div>{localizationStore!.t('No data text')}</div>)
        }

        return (
            <div>
                <ReactTable
                    data={settings}
                    columns={getTableSettingsColums()}
                    defaultPageSize={configStore!.getPageSize}
                    className="-striped -highlight"
                    noDataText={localizationStore!.t('No data text')}
                    filterable={true}
                    previousText={localizationStore!.t('Previous')}
                    nextText={localizationStore!.t('Next')}
                    pageText={localizationStore!.t('Page')}
                    ofText={localizationStore!.t('of')}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Settings/SettingsView.tsx